import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  popoverXS: {
    display: 'flex',
    alignItems: 'flex-end',
    '& .MuiPopover-paper': {
      position: 'relative',
      width: '100%',
      maxWidth: '100%',
      maxHeight: '100%',
      top: 'inherit !important',
      left: 'inherit !important',
      borderRadius: theme.spacing(1, 1, 0, 0),
    },
  },

  wrapperContent: {
    width: 'auto',
    [theme.breakpoints.up('sm')]: {
      maxWidth: theme.spacing(49),
    },
  },
  header: {
    padding: theme.spacing(3, 3, 3, 4),
    display: 'flex',
    alignItems: 'center',
  },
  userInfo: {
    marginLeft: theme.spacing(2),
    paddingRight: theme.spacing(3),
    wordBreak: 'break-word',
  },
  email: {
    color: theme.palette.grey[200],
    wordBreak: 'break-word',
  },
  closeButton: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    alignSelf: 'flex-start',
    marginLeft: 'auto',
  },
  closeButtonIcon: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    color: theme.palette.primary.dark,
  },
  buttonLogout: {
    width: '100%',
    borderRadius: 0,
    height: theme.spacing(7),
    display: 'flex',
    textAlign: 'left',
    justifyContent: 'flex-start',
    padding: theme.spacing(0, 0, 0, 4),
    borderTop: `solid 1px ${theme.palette.primary.lighter}`,
  },
  iconButtonLogout: {
    display: 'inline-block',
    color: theme.palette.primary,
  },
  textButtonLogout: {
    display: 'inline-block',
    marginLeft: theme.spacing(4),
    color: theme.palette.primary,
  },
}))

export default useStyles
